<template>
    <div>
        <h1>{{ $t("admin.adminUserList.header") }}</h1>
        <form id="search" @submit="userSearch">
            <label for="searchTerm">{{ $t("admin.adminUserList.search") }}: </label>
            <input id="searchTerm" name="searchTerm" v-model="searchTerm"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminUserList.button.search')">
        </form>

        <table v-if="userList" class="datatable">
            <caption class="caption">User list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminUserList.table.emailAddress") }}</th>
                <th scope="col">{{ $t("admin.adminUserList.table.givenName") }}</th>
                <th scope="col">{{ $t("admin.adminUserList.table.familyName") }}</th>
                <th scope="col">{{ $t("admin.adminUserList.table.enabled") }}</th>
                <th scope="col">{{ $t("admin.adminUserList.table.userType") }}</th>
            </tr>
            <tr v-for="(user, index) in userList" v-bind:key="index">
                <td><router-link :to="'/admin/userView/' + user.userId">{{ user.emailAddress }}</router-link></td>
                <td>{{ user.givenName }}</td>
                <td>{{ user.familyName }}</td>
                <td>{{ user.enabled ? $t("common.yes") : $t("common.no") }}</td>
                <td>{{ user.userType === 0 ? $t("admin.adminUserList.user") : $t("admin.adminUserList.admin") }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminUserList',
        data: function() {
            return { userList: [], searchTerm: "" };
        },
        created: function() {
            this.userSearch(null);
        },
        methods: {
            userSearch: function (event) {
                adminService.userSearch(this.searchTerm).then((data) => {
                    this.userList = data;
                }).catch((err) => {
                    console.error('Unable to search user: ', err)
                });
                if (event) {
                    event.preventDefault()
                }
            }
        }
    }
</script>
